import React, { useState, useEffect } from 'react';
import { IoArrowBack } from 'react-icons/io5';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import VendorForm1 from './VendorForm1';
import VendorForm2 from './VendorForm2';
import VendorForm3 from './VendorForm3';
import * as apicall from '../../components/Apicall';
import Skeleton from 'react-loading-skeleton';
import VendorPayoutPricing from './VendorPayoutPricing';

const VendortSignUp = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const { vendor_id } = useParams();
    const [step, setStep] = useState(1);
    const [is_display, setIs_display] = useState(false);
    const [vendorData, setVendorData] = useState({});
    console.log(vendorData, "vendorData")
    const { searchTerm, statusFilter, ratingFilter, serviceTypeFilter, filterApplied, } = location.state || {};

    const nextStep = () => {
        setStep(step + 1);
    };

    const prevStep = () => {
        setStep(step - 1);
    };

    const setData = async (data) => {
        setVendorData(data)
        nextStep()
    };
    // Packers & Movers keeps its own route-based pricing page; every other service uses the common price page.
    const isPackersOnly = (v) => (v?.services?.length ? v.services.length === 1 && v.services[0].name === 'Packers & Movers' : v?.service_name === 'Packers & Movers');
    const save = async (pricingData) => {
        try {
            var data = {
                name: vendorData.vendorName,
                // The vendor record holds one service: the first picked. The others are priced through their offerings.
                service_type: Array.isArray(vendorData.serviceType) ? vendorData.serviceType[0] : vendorData.serviceType,
                service_ids: Array.isArray(vendorData.serviceType) ? vendorData.serviceType : [vendorData.serviceType],
                mobile: vendorData.contactNumber,
                country_id: vendorData.country,
                state_id: vendorData.state,
                city_id: vendorData.city,
                email: vendorData.email,
                address: vendorData.address,
                memberShip_type: vendorData.membershipType,
                start_date: vendorData.membershipStartDate,
                end_date: vendorData.membershipEndDate,
                bank_name: vendorData.bankName,
                account_number: vendorData.bankAccountNumber,
                bank_ifsc: vendorData.bankIFSC,
                name_on_bank: vendorData.nameAsPerBank,
                tradeLicense_number: vendorData.tradersLicenseNumber,
                license_exp_date: vendorData.licenseExpDate,
                operator_name: vendorData.operatorName,
                operator_contact_number: vendorData.operatorContactNum,
                month: pricingData.month,
                service_offerings_price: pricingData.service_offerings_price
            }
            var res = isPackersOnly(vendorData)
                ? await apicall.post(data, 'vendor/' + vendor_id)
                : await apicall.post(data, 'vendorPestControl/' + vendor_id);

            if (res.success) {
                toast.success(res.message);
                navigate('/vendors')
            } else {
                toast.error(res.message);
            }

        } catch (error) {
            toast.error(error.message.replace('Error:', ''))
        } finally {
        }

    }
    const getVendorDetails = async () => {
        try {
            const res = await apicall.get("vendorDetails/" + vendor_id);
            var v_data = res.data[0];
            console.log(v_data, "v_data")
            console.log(v_data?.pmlocation)
            const transformedData = v_data.pmlocation
                ? [{
                    vendor_id: v_data.vendor_id,
                    service_location_id: v_data.pmlocation.map(loc => loc.service_location_id).join(","),
                    name: v_data.pmlocation.map(loc => loc.name).join("-")
                }]
                : []; // If no data, return an empty array

            console.log(v_data, "v_data")
            var d = {
                vendorName: v_data.vendor_name,
                service_name: v_data.service_name,
                services: (v_data.service_names || [v_data.service_name]).map((name) => ({ name })),
                serviceType: v_data.service_id ? v_data.service_id : v_data.service_name,
                contactNumber: v_data.phone_number,
                country_name: v_data.country_name,
                country: v_data.country_id,
                state_name: v_data.state_name,
                state: v_data.state_id,
                city_name: v_data.city_name,
                city: v_data.city_id,
                email: v_data.email,
                address: v_data.address,
                plan_name: v_data.plan_name,
                membershipType: v_data.plan_id,
                membershipStartDate: new Date(v_data.start_date).toISOString().split('T')[0],
                membershipEndDate: new Date(v_data.end_date).toISOString().split('T')[0],
                bankName: v_data.bank_name,
                bankAccountNumber: v_data.bank_account_number,
                bankIFSC: v_data.IFSC,
                nameAsPerBank: v_data.name_on_bank,
                tradersLicenseNumber: v_data.tradeLicense_number,
                operator_name: v_data.operator_name,
                operator_contact_number: v_data.operator_contact_number,
                licenseExpDate: new Date(v_data.license_exp_date).toISOString().split('T')[0],
                serviceOffering: v_data.service_offerings,
                selectlocation: v_data.service_location,
                selectPMlocation: transformedData,
                selectedNewServiceType: v_data.servicetype
            }
            console.log(d, "d")
            setVendorData(d);
        } catch (error) {
            console.error("Failed to fetch services:", error);
        } finally {
            setIs_display(true);
        }
    }



    useEffect(() => {
        if (vendor_id != 0) {
            getVendorDetails()
        } else {
            setIs_display(true)
        }
    }, []);

    return (

        <div className="container mt-4">
            <div className="card p-4 shadow-lg vf-page">
                <h1 className="heading">
                    <span className="me-4 pointer">
                        <IoArrowBack
                            size={24}
                            className="me-2 pointer"
                            onClick={() =>
                                navigate('/vendors', {
                                    state: {
                                        searchTerm,
                                        statusFilter,
                                        ratingFilter,
                                        serviceTypeFilter,
                                        filterApplied,
                                    },
                                })
                            }
                        />
                    </span>
                    {vendor_id == 0 ? "Add Vendor" : "Edit Vendor"}
                </h1>
                <hr className='mb-4' />

                {step === 1 && is_display && (

                    <VendorForm1
                        navigate={navigate}
                        vendorData={vendorData}
                        vendor_id={vendor_id}
                        onSubmit={(data) => { setData(data) }}
                    />
                )}

                {step === 2 && (
                    isPackersOnly(vendorData) ? (
                        <VendorForm2
                            vendorData={vendorData}
                            vendor_id={vendor_id}
                            prev={prevStep}
                            onSubmit={(data) => { save(data); }}
                        />
                    ) : (
                        <VendorPayoutPricing
                            vendorData={vendorData}
                            vendor_id={vendor_id}
                            prev={prevStep}
                            onSubmit={(data) => { save(data); }}
                        />
                    )
                )}

            </div>

        </div>
    );
};

export default VendortSignUp;